export default __webpack_public_path__ + "static/media/ingosstrah.2f1ddade.svg";